import styled from 'styled-components';

import Button from './Button';

const CardActionButtons = styled.div`
  display: flex;
  justify-content: ${({ children }) =>
    children.length < 3 ? 'flex-start' : 'space-between'};
  padding: 0 8px;

  ${Button} {
    ${({ children }) => (children.length < 3 ? 'margin-right: 16px;' : '')};
  }
`;

export default CardActionButtons;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/CardActionButtons.js